import { ArrowLeft, ChevronDown, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { CandidateCard } from "../components/CandidateCard";
import { mockCandidates } from "../data/mock-candidates";

export function SearchResultsPage() {
  return (
    <div>
      {/* 上部ヘッダー */}
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Link
            className="flex items-center gap-1 text-sm text-purple-600 hover:text-purple-700"
            to="/direct-recruiting-sample"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            検索条件を変更
          </Link>
          <span className="text-gray-300">|</span>
          <span className="text-sm text-gray-700">
            該当件数: <span className="font-bold text-gray-900">{mockCandidates.length}</span>件
          </span>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-xs text-gray-500">並び順</span>
          <select className="rounded border border-gray-300 bg-white px-2 py-1 text-[13px]">
            <option>新規登録順</option>
            <option>ログイン順</option>
            <option>マッチ順</option>
            <option>年収順</option>
          </select>
          <button
            className="flex items-center gap-1 rounded border border-gray-300 px-2 py-1 text-xs text-gray-500 hover:bg-gray-50"
            type="button"
          >
            <Download className="h-3 w-3" />
            CSV
          </button>
        </div>
      </div>

      {/* 一括操作バー */}
      <div className="flex items-center gap-3 rounded-t-lg border border-gray-200 border-b-0 bg-gray-50 px-4 py-2">
        <label className="flex items-center gap-1.5 text-[13px]">
          <input className="accent-purple-600" type="checkbox" />
          <span className="text-gray-600">全選択</span>
        </label>
        <div className="h-4 w-px bg-gray-300" />
        <button
          className="rounded bg-purple-600 px-3 py-1 text-xs text-white hover:bg-purple-700"
          type="button"
        >
          スカウトを送る
        </button>
        <button
          className="rounded border border-gray-300 bg-white px-3 py-1 text-xs text-gray-600 hover:bg-gray-50"
          type="button"
        >
          気になるに追加
        </button>
      </div>

      {/* 候補者リスト */}
      <div className="overflow-hidden rounded-b-lg border border-gray-200">
        {mockCandidates.map((candidate) => (
          <CandidateCard candidate={candidate} key={candidate.id} />
        ))}
      </div>

      {/* ページネーション */}
      <div className="mt-6 flex items-center justify-center gap-1">
        <span className="rounded bg-purple-600 px-2.5 py-1 text-[13px] text-white">1</span>
        {[2, 3, 4, 5].map((n) => (
          <button
            className="rounded border border-gray-200 bg-white px-2.5 py-1 text-[13px] text-gray-600 hover:bg-gray-50"
            key={n}
            type="button"
          >
            {n}
          </button>
        ))}
        <span className="px-1 text-gray-400 text-[13px]">...</span>
        <button
          className="rounded border border-gray-200 bg-white px-2.5 py-1 text-[13px] text-gray-600 hover:bg-gray-50"
          type="button"
        >
          125
        </button>
        <button
          className="ml-1 flex items-center gap-0.5 rounded border border-gray-200 bg-white px-2.5 py-1 text-[13px] text-gray-600 hover:bg-gray-50"
          type="button"
        >
          次へ
          <ChevronDown className="h-3 w-3 -rotate-90" />
        </button>
      </div>
    </div>
  );
}
